import React, { useEffect, useState } from 'react';

import ImagesIcon from 'icons/ic-images.svg';
import PdfIcon from 'icons/ic-pdf.svg';
import LoadingIcon from 'icons/loading.svg';
import moment from 'moment';
import PropTypes from 'prop-types';

export default function Image({ attachment }) {
  const [timestamp, setTimestamp] = useState(null);

  const {
    attachedProcessed: isProcessed,
    imageThumbUrl,
    originalImageThumbUrl,
    recordType,
  } = attachment;

  let thumbnailUrl;
  if (imageThumbUrl && timestamp && isProcessed) {
    thumbnailUrl = imageThumbUrl;
  } else if (
    originalImageThumbUrl &&
    !imageThumbUrl &&
    timestamp &&
    !isProcessed
  ) {
    thumbnailUrl = originalImageThumbUrl;
  }

  useEffect(() => {
    setTimestamp(moment().unix());
  }, [imageThumbUrl]);

  return (
    <div className='attachments__viewer-attachment attachments__viewer-attachment--compact-mode'>
      {thumbnailUrl ?
        <>
          <img
            alt='Attachment'
            className='attachments__viewer-image'
            src={`${thumbnailUrl}?timestamp=${timestamp}`}
          />
          {recordType === 'pdf' && (
            <PdfIcon
              className='attachments__pdf-icon [&_rect]:tw-fill-red-500'
              height={18}
              width={36}
            />
          )}
        </>
      : <>
          <div className='attachments__icon-wrapper tw-apply-loading-spinner--blue-light'>
            <LoadingIcon className='animated-spinner' height={40} width={40} />
          </div>
          <div className='attachments__icon-wrapper'>
            <ImagesIcon
              className='[&_path]:tw-fill-grey-500'
              height={14}
              width={14}
            />
          </div>
        </>
      }
    </div>
  );
}

Image.propTypes = {
  attachment: PropTypes.object.isRequired,
};
